<template>
  <div>
    <header class="header">
      <div class="header_box">
        <div class="logo">
          <router-link :to="{ name: 'brand/home' }">
            <img class="pc_logo" src="/media/img/logo_raidiobiz.svg" alt="홈"/>
          </router-link>
        </div>
        <div class="right_menu">
          <button @click="linkLogin()">로그인</button>
          <button @click="linkSignUp()">회원가입</button>
        </div>
      </div>
    </header>
    <div class="main cs policy">
      <div class="main_box">
        <h1>이용약관</h1>
        <div class="cs_main">
          <div class="side_depth_box">
            <div class="one_depth">
              <router-link
                class="policy"
                :to="{
                  name: 'HomeService',
                }"
                :class="{ on : this.$route.path === '/brand/stplat/service' }"
              >
                서비스 이용약관
              </router-link>
              <router-link
                class="personal"
                :to="{
                  name: 'HomePrivacy',
                }"
                :class="{ on : this.$route.path === '/brand/stplat/privacy' }"
                >개인정보 처리방침
              </router-link>
              <!-- <router-link
                class="marketing on"
                :to="{
                  name: 'HomeMarketing',
                }"
                >마케팅 정보 수신
              </router-link> -->
            </div>
          </div>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "@vue/composition-api";
import router from "@/router";

export default defineComponent({
  name: 'HomePolicy',

  methods: {
    /**
     * * 로그인 페이지로 이동
     */
    linkLogin () {
      router.push({ name: "brand/login" });
    },

    /**
     * * 회원 가입 페이지로 이동
     */
    linkSignUp () {
      router.push({ name: "brand/sineUp" });
    }
  }
});
</script>

<style src="@/assets/css/content.css"></style>
<style src="@/assets/css/font.css"></style>
